import { Model as BaseModel } from 'vue-api-query'
import qs from 'qs'

export default class Model extends BaseModel {
    //
    static appends  = []
    static errors   = {}
    static filters  = []
    static forms    = {}
    static headers  = []
    static includes = []
    
    /**
     * define a base url for a REST API
     */
    baseURL () {
        return process.env.VUE_APP_API_ROUTE
    }

    /**
     * 
     */
    clean ( props ) {

        //
        var clone = this.clone()

        //
        Object.keys( clone ).forEach( key => {
            if ( !props.some( prop => prop === key ) ) {
                delete clone[ key ]
            }            
        })

        //
        return clone
    }

    /**
     * 
     */
    clone () {
        return Object.assign( Object.create( Object.getPrototypeOf(this)), this)
    }

    /**
     * { function_description }
     *
     * @param      {string}  [path='excel']  The path
     * @param      {<type>}  [params={}]     The parameters
     * @return     {<type>}  { description_of_the_return_value }
     */
    excel(path = 'excel', params = {}) {
        return this.request({
            method: 'GET',
            params: params,
            paramsSerializer: function (params) {
                return qs.stringify(params, {arrayFormat: 'brackets'})
            },
            responseType: 'blob',
            url: path.length > 0 ? this.fullURL().concat('/').concat(path) : this.fullURL(),
        })
    }

    /**
     * Fetches the given fetch key.
     *
     * @param      {string}  fetchKey  The fetch key
     * @return     {<type>}  { description_of_the_return_value }
     */
    fetch(fetchKey) {
      return this.constructor.fetches[fetchKey+'_id'].modeler().find(this[fetchKey+'_id'])
    }

    /**
     * 
     */
    static async fetchDataTable ( limit, page, sort, params = {} ) {

        //
        try {

            //
            return ( await this.modeler().limit( limit ).page( page ).orderBy( sort ).params( params ).get() )
        } catch ( error ) {

            //
            //console.error( error )
            
            //
            return []
        }
    }

    /**
     * get the full url for the current model
     */
    fullURL () {
        return [ this.baseURL(), this.resource(), this.id ].join("/")
    }

    /**
     * Gets the property.
     *
     * @param      {<type>}  path    The path
     * @return     {<type>}  The property.
     */
    getProperty(path, prevent) {
        return path.split('.').reduce(this.reduceHasProperty, this) || prevent
    }

    /**
     * 
     */
    static modeler () {
        return this.append(this.appends).include(this.includes)
    }

    /**
     *
     */
    pdf() {
        return this.request({
            responseType: 'blob',
            method: 'GET',
            url: this.fullURL().concat('/pdf'),
        })
    }

    /**
     * Reduces the has property.
     *
     * @param      {<type>}  parent    The parent
     * @param      {<type>}  property  The property
     * @param      {<type>}  index     The index
     * @return     {<type>}  { description_of_the_return_value }
     */
    reduceHasProperty(parent, property) {
        return typeof parent === "object" && parent !== null ? parent[property] : undefined
    }

    /**
     * 
     */
    replace (data) {
        return this.$http.request({
            method: "patch",
            url: this._fromResource,
            data
        })
    }
    
    /**
     * implement a default request method 
     * 
     * @param {*} config 
     */
    request (config) {
        return this.$http.request(config)
    }

    /**
     * 
     */
    reset () {
        return this
    }

    /**
     *
     */
    showFile = (filename, fileExtend) => res => {
        
        //
        var fileLink = document.createElement('a')
        var fileURL = URL.createObjectURL(res.data)

        //
        fileLink.href = fileURL
        fileLink.download = filename.concat('.').concat(fileExtend)

        // 
        fileLink.click()
    }
}